export default __webpack_public_path__ + "static/media/code4.707ae726.png";